const WEBSITE_ID = 'website';
const SCROLL_SCROLLED_MARGIN = 75;

/**
 * @returns {boolean}
 */
export function hasWebsite() {
    return (document.getElementById(WEBSITE_ID) !== null);
}

/**
 * @returns {HTMLElement}
 */
export function getWebsite() {
    return document.getElementById(WEBSITE_ID);
}

/**
 * Kijkt of de gebruiker al gescrollt heeft.
 *
 * @param {number} scrollY
 *
 * @returns {boolean}
 */
export function visitorHasScrolled(scrollY) {
    return (scrollY > SCROLL_SCROLLED_MARGIN);
}